// QA map for today's utility disconnections (electricity + water together):
// one polyline per geocoded street, color-coded by service_type.
import L from "leaflet";

const COLOR_BY_SERVICE_TYPE = {
  electricity: "#ffc107", // yellow
  water: "#0d6efd", // blue
};
const DEFAULT_COLOR = "#6c757d"; // grey fallback for unknown types

delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl:
    "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon-2x.png",
  iconUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-icon.png",
  shadowUrl: "https://unpkg.com/leaflet@1.9.4/dist/images/marker-shadow.png",
});

function popupContent(outage) {
  return (
    "<div>" +
    '<strong style="font-size:0.9rem">' +
    outage.street_name +
    "</strong> (" +
    outage.branch +
    ")<br>" +
    '<span class="badge" style="background:' +
    (COLOR_BY_SERVICE_TYPE[outage.service_type] || DEFAULT_COLOR) +
    '">' +
    outage.service_type +
    "</span><br>" +
    outage.time_range +
    "<br>" +
    '<span style="font-size:0.8rem;color:#666">' +
    (outage.building_numbers || "") +
    "</span><br>" +
    '<span class="badge bg-secondary">' +
    outage.status +
    "</span>" +
    "</div>"
  );
}

function initializeOutagesMap() {
  const container = document.querySelector("[data-outages-map]");
  if (!container) return;

  const outagesUrl = container.getAttribute("data-outages-url");
  const map = L.map(container).setView([48.7503, 30.2231], 13);

  L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    attribution:
      '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
    maxZoom: 19,
  }).addTo(map);

  fetch(outagesUrl)
    .then(function (r) {
      return r.json();
    })
    .then(function (outages) {
      const bounds = [];

      outages.forEach(function (outage) {
        if (outage.coordinates && outage.coordinates.length > 0) {
          outage.coordinates.forEach(function (segment) {
            const polyline = L.polyline(segment, {
              color: COLOR_BY_SERVICE_TYPE[outage.service_type] || DEFAULT_COLOR,
              weight: 5,
              opacity: 0.8,
            }).addTo(map);
            polyline.bindPopup(popupContent(outage));
            segment.forEach(function (point) {
              bounds.push(point);
            });
          });
        } else {
          // No geometry yet - nothing to place on the map without a
          // representative point, so it's surfaced in a warning list instead.
          console.warn(
            "No geometry for street (not geocoded yet):",
            outage.street_name,
            outage.status,
          );
        }
      });

      if (bounds.length > 0) {
        map.fitBounds(bounds, { padding: [20, 20] });
      }
    })
    .catch(function (err) {
      console.error("Failed to load utility outages:", err);
    });
}

document.addEventListener("turbo:load", initializeOutagesMap);
document.addEventListener("turbolinks:load", initializeOutagesMap);
document.addEventListener("DOMContentLoaded", initializeOutagesMap);
